export const getRandomColor = (): string => {
  // 生成一个随机的颜色值
  const letters = "0123456789ABCDEF";
  let color = "#";
  for (let i = 0; i < 6; i++) {
    color += letters[Math.floor(Math.random() * 16)];
  }
  return color;
};

export const generateRandomKey = (): string => {
  return Math.random().toString(12);
};

export interface StorageUtils {
  getItem(key: string): string;
  addItem(key: string, value: string): void;
  removeItem(key: string): void;
  clean(): void;
}

//持久化工具
export const storageUtils: StorageUtils = {
  getItem(key: string): string {
    return localStorage.getItem(key) ?? "";
  },
  addItem(key: string, value: string) {
    localStorage.setItem(key, value);
  },
  removeItem(key: string) {
    localStorage.removeItem(key);
  },
  clean() {
    localStorage.clear();
  },
};

/**
 * 格式化金额单位
 */
export const formatPrice = (value: number) => {
  return (value * 0.01).toFixed(2);
};

/**
 * 防抖
 */
export const deBounce = (callback: VoidFunction, delay: number) => {
  let timer: any;
  return function () {
    if (timer) {
      clearTimeout(timer);
    }
    timer = setTimeout(() => {
      callback.apply(null);
      timer = null;
    }, delay);
  };
};

/**
 * 节流
 */
export const throttle = (callback: VoidFunction, delay: number) => {
  let preCall: number = +new Date();
  return function () {
    const currentTime: number = +new Date();
    if (currentTime - preCall >= delay) {
      preCall = currentTime;
      callback.apply(null);
    }
  };
};

/**
 * 通过类型判断是否处方药
 * @param prescriptionType 处方类型
 * @returns
 */
export const checkIsRxByPrescriptionType = (
  prescriptionType: string | number
): boolean => {
  const isRx: boolean =
    Number(prescriptionType) === 4 || Number(prescriptionType) === 5;
  return isRx;
};

/**
 * 打开常青藤网上药店APP
 */
export const handleOpenIvyphaAPP = () => {
  console.log("打开", process.env);
  window.open(process.env.REACT_APP_OPEN_IVYPHA_SCHEME);
  setTimeout(() => {
    window.open(process.env.REACT_APP_DOWNLOAD_IVYPHA_URL);
  }, 1000);
};

export const formatDuration = (milliseconds: number): string => {
  const msInSecond = 1000;
  const msInMinute = msInSecond * 60;
  const msInHour = msInMinute * 60;
  const msInDay = msInHour * 24;
  const msInMonth = msInDay * 30;
  const msInYear = msInDay * 365;

  let remainingMs = milliseconds;

  const years = Math.floor(remainingMs / msInYear);
  remainingMs %= msInYear;

  const months = Math.floor(remainingMs / msInMonth);
  remainingMs %= msInMonth;

  const days = Math.floor(remainingMs / msInDay);
  remainingMs %= msInDay;

  const hours = Math.floor(remainingMs / msInHour);
  remainingMs %= msInHour;

  const minutes = Math.floor(remainingMs / msInMinute);
  remainingMs %= msInMinute;

  const seconds = Math.floor(remainingMs / msInSecond);

  const parts: string[] = [];

  if (years > 0) parts.push(`${years}年`);
  if (months > 0) parts.push(`${months}月`);
  if (days > 0) parts.push(`${days}日`);
  if (hours > 0) parts.push(`${hours}小时`);
  if (minutes > 0) parts.push(`${minutes}分钟`);
  if (seconds > 0) parts.push(`${seconds}秒`);

  return parts.length > 0 ? parts.join(" ") : "0秒";
};

/**
 * 美化数字显示
 */
export const beautifyNumber = (num: number): string => {
  if (num < 1000) {
    return num.toString();
  } else if (num >= 1000 && num < 10000) {
    return (num / 1000).toFixed(1) + "k";
  } else {
    return (num / 10000).toFixed(1) + "w";
  }
};

/**
 * 基于阿里云oss的图片略缩图
 */
export const get_image_thumbnail = (img_url: string): string => {
  const after_fix = process.env.REACT_APP_THUMBNAIL_AFTER_FIX ?? "";
  return `${img_url}${after_fix}`;
};

export const filter_category_of = <T = Object>(
  array: Array<T>,
  key: (item:T)=>string
): Record<string, Array<T>> => {
  //筛选出所有类别
  const categories = new Set(
    array.map((item:T) => {
      if (typeof item === "object") {
        return key(item);
      } else {
        return item;
      }
    })
  );

  const result:Record<string,Array<T>>={}
  for (const item of array) {
    if(typeof item === "object"){
        const _key=key(item);
        if(categories.has(_key)){
          const _item=result[_key]??[]
          _item.push(item)
          result[_key]=_item
        }
    }else{
      const _key=item as string;
      const _item=result[_key]??[]
      _item.push(item)
      result[_key]=_item
    }
  }
  return result;
};


type DateISOString=string;
/**
 * 获取两个日期之间的所有日期
 * 返回格式为yyyy-mm-dd的数组
 */
export const get_dates_inRange = (start:string, end:string):Array<DateISOString> => {
  const dates = [];
  let currentDate = new Date(start);
  const endDate = new Date(end);

  while (currentDate <= endDate) {
    dates.push(currentDate.toISOString().split('T')[0]);
    currentDate.setDate(currentDate.getDate() + 1);
  }

  return dates;
};
